import { render } from "./NotifyList.vue?vue&type=template&id=81f14a5e&scoped=true"
import script from "./NotifyList.vue?vue&type=script&lang=js"
export * from "./NotifyList.vue?vue&type=script&lang=js"

import "./NotifyList.vue?vue&type=style&index=0&id=81f14a5e&lang=scss&scoped=true"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f14a5e"]])

export default __exports__